import { render, staticRenderFns } from "./DbHealthTab.vue?vue&type=template&id=77cd9bd8&scoped=true"
import script from "./DbHealthTab.vue?vue&type=script&lang=js"
export * from "./DbHealthTab.vue?vue&type=script&lang=js"
import style0 from "./DbHealthTab.vue?vue&type=style&index=0&id=77cd9bd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77cd9bd8",
  null
  
)

export default component.exports